import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";

export const useEventManagerStyles = makeStyles((theme) => ({
	root: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(6),
	},
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		flexWrap: "wrap",
		marginBottom: theme.spacing(2),
	},
	headerActions: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(2),
	},
	gameSelect: {
		minWidth: 160,
		"& .MuiSelect-nativeInput": { margin: 0, padding: 0, border: 0 },
	},

	card: {
		backgroundColor: Colors.panel,
		border: `1px solid ${Colors.panelLight}`,
		borderRadius: 12,
		padding: 10,
		marginBottom: 8,
	},
	cardHead: {
		display: "flex",
		gap: 14,
		alignItems: "flex-start",
		flexWrap: "wrap",
	},
	thumb: {
		width: 120,
		height: 60,
		borderRadius: 8,
		objectFit: "cover",
		backgroundColor: Colors.panelDark,
		flexShrink: 0,
	},
	cardText: { flex: 1, minWidth: 0 },
	titleRow: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		flexWrap: "wrap",
	},
	name: { fontSize: 16, fontWeight: 500, color: Colors.primary },
	eventId: { fontSize: 13, color: Colors.primaryDarker },
	status: { fontSize: 13, color: Colors.primaryDark, marginTop: 6 },
	cardSide: {
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		gap: 16,
		flexShrink: 0,
		[theme.breakpoints.down("xs")]: { marginLeft: 0, flexBasis: "100%" },
	},
	view: {
		backgroundColor: Colors.pickstop,
		color: Colors.panelDark,
		textTransform: "none",
		"&:hover": { backgroundColor: Colors.secondaryDark },
	},
	hiddenToggle: { marginRight: -6 },

	tabs: {
		display: "inline-flex",
		minHeight: 30,
		padding: 3,
		borderRadius: 999,
		backgroundColor: Colors.panelDark,
		marginTop: 6,
	},
	tab: {
		fontSize: 13,
		fontWeight: 500,
		letterSpacing: 0,
		textTransform: "none",
		color: Colors.primaryDark,
		minHeight: 24,
		minWidth: "unset",
		padding: "4px 12px",
		borderRadius: 999,
		opacity: 1,
		backgroundColor: "transparent",
		transition: "background-color 120ms ease, color 120ms ease",
		"&:hover": { color: Colors.primary, backgroundColor: "transparent" },
		"&.Mui-selected": {
			color: Colors.pickstop,
			backgroundColor: "rgba(255, 255, 255, 0.13)",
		},
	},
	panel: { padding: "16px 0 4px" },

	pill: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		height: 22,
		padding: "0 10px",
		borderRadius: 999,
		border: "1px solid",
		fontSize: 11,
		fontWeight: 600,
		letterSpacing: ".08em",
		textTransform: "uppercase",
		whiteSpace: "nowrap",
		"& svg": { fontSize: 14 },
	},
	// Uppercase glyphs sit above the optical centre.
	pillCaps: { boxSizing: "border-box", paddingTop: 2 },
	pillLive: { borderColor: Colors.pickstop, color: Colors.pickstop },
	pillUpcoming: { borderColor: Colors.primaryDark, color: Colors.primaryDark },
	pillDim: { borderColor: Colors.panelLight, color: Colors.primaryDarker },
	pillSent: {
		borderColor: Colors.pickstopGreen,
		color: Colors.primary,
		"& svg": { color: Colors.pickstopGreen },
	},
	pillPending: { borderColor: Colors.primaryDark, color: Colors.primaryDark },
	pillText: {
		textTransform: "none",
		fontSize: 12,
		fontWeight: 500,
		letterSpacing: ".02em",
	},

	rowGrid: {
		display: "grid",
		gridTemplateColumns: "120px 1fr",
		rowGap: 12,
		alignItems: "center",
	},
	rowLabel: { fontSize: 13, color: Colors.primaryDark },
	labelInfo: { display: "flex", alignItems: "center" },
	infoIcon: {
		fontSize: 16,
		marginLeft: 6,
		cursor: "help",
		color: Colors.primaryDark,
	},
	pills: {
		display: "flex",
		flexWrap: "wrap",
		gap: 8,
		alignItems: "center",
	},

	fields: {
		display: "grid",
		gridTemplateColumns: "130px 1fr",
		rowGap: 12,
		columnGap: 16,
		"& input": { margin: 0, borderStyle: "solid" },
		alignItems: "center",
	},
	input: {
		width: "100%",
		boxSizing: "border-box",
		margin: 0,
		padding: 6,
		color: Colors.primary,
		backgroundColor: Colors.panelDark,
		border: `1px solid ${Colors.panelLight}`,
		borderRadius: 4,
	},
	rewardSelect: {
		minWidth: 160,
		alignSelf: "flex-start",
		"& .MuiSelect-select": { paddingLeft: 7 },
	},
	saveRow: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: 14,
	},

	actionsList: {
		display: "flex",
		flexDirection: "column",
		gap: 10,
		alignItems: "flex-start",
	},
	actionsNote: { fontSize: 13, color: Colors.primaryDark },

	facts: {
		display: "grid",
		gridTemplateColumns: "auto 1fr",
		columnGap: theme.spacing(2),
		rowGap: 2,
	},
	label: { opacity: 0.7 },
	section: { marginTop: theme.spacing(2), marginBottom: theme.spacing(1) },
	grid: { marginBottom: theme.spacing(2) },
}));
